var _ellipse, _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 233,
    viewBox: "0 0 222 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.676,
    cy: 206.19,
    rx: 108.137,
    ry: 17.4075,
    fill: "#F2F3F4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 130.257,
    y: 82.1367,
    width: 63.2515,
    height: 114.193,
    rx: 4.41126,
    transform: "rotate(31.3498 130.257 82.1367)",
    fill: "#E0E2E3",
    style: {
      mixBlendMode: "multiply"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 129.757,
    y: 77.4515,
    width: 63.5388,
    height: 113.83,
    rx: 3.41639,
    transform: "rotate(31.8365 129.757 77.4515)",
    fill: "white",
    stroke: "#E0E2E3",
    strokeWidth: 2.20563
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 109.637,
    y: 53.7492,
    width: 63.5388,
    height: 113.83,
    rx: 3.41639,
    transform: "rotate(22.7119 109.637 53.7492)",
    fill: "white",
    stroke: "#E0E2E3",
    strokeWidth: 2.20563
  })), /*#__PURE__*/React.createElement("rect", {
    x: 111.488,
    y: 57.8774,
    width: 63.2515,
    height: 114.193,
    rx: 4.41126,
    transform: "rotate(22.3219 111.488 57.8774)",
    fill: "#E0E2E3",
    style: {
      mixBlendMode: "multiply"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 81.7339,
    y: 41.7874,
    width: 63.5388,
    height: 113.83,
    rx: 3.41639,
    transform: "rotate(9.69185 81.7339 41.7874)",
    fill: "white",
    stroke: "#E0E2E3",
    strokeWidth: 2.20563
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 76.0785,
    y: 149.553,
    width: 87.814,
    height: 3.30844,
    rx: 1.65422,
    transform: "rotate(-78.895 76.0785 149.553)",
    fill: "#E0E2E3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 83.6536,
    y: 151.04,
    width: 63.8145,
    height: 3.30844,
    rx: 1.65422,
    transform: "rotate(-78.895 83.6536 151.04)",
    fill: "#E0E2E3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.36bd47f5a63ddda95a4a754e80e6ecb5.svg";
export { ForwardRef as ReactComponent };